import React from 'react';

const CurrentCityContext = React.createContext(null); // default value is null

export default CurrentCityContext;